/**
 * Podporované jazyky
 */
export interface Language {
  iso_639_1: string;
  iso_639_2: string;
  title: string;
}

export const CZECH: Language = {
  iso_639_1: 'cs',
  iso_639_2: 'cze',
  title: 'Čeština'
};

export const ENGLISH: Language = {
  iso_639_1: 'en',
  iso_639_2: 'eng',
  title: 'English'
};

export const GERMAN: Language = {
  iso_639_1: 'de',
  iso_639_2: 'ger',
  title: 'Deutsch'
};

export const RUSSIAN: Language = {
  iso_639_1: 'ru',
  iso_639_2: 'rus',
  title: 'Русский'
};

/**
 * Jmenný prostor Language
 */
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace Language {
  /**
   * Získat jazyk podle hodnoty (ISO 639-1)
   *
   * @param value
   */
  export function getLanguageByValue(value: string): Language {
    switch (value) {
      case CZECH.iso_639_1:
        return CZECH;
      case ENGLISH.iso_639_1:
        return ENGLISH;
      case GERMAN.iso_639_1:
        return GERMAN;
      case RUSSIAN.iso_639_1:
        return RUSSIAN;
    }

    return CZECH;
  }

  export function getLanguageByIso_639_1(iso_639_1: string): Language {
    return getLanguageByKey('iso_639_1', iso_639_1);
  }

  export function getLanguageByIso_639_2(iso_639_2: string): Language {
    return getLanguageByKey('iso_639_2', iso_639_2);
  }

  export function getLanguageByKey(key: string, value: string): Language {
    return getLanguages().find((l) => l[key] === value);
  }

  export function getLanguages(): Language[] {
    return [CZECH, ENGLISH, GERMAN, RUSSIAN];
  }
}
